import React from "react"
import { Link } from "react-router-dom"
import { FaPen } from "react-icons/fa"
import _ from "lodash"

function ProgramTableCell({ flexRender, cell }) {
  const rowData = _.get(cell, "row.original")
  const cellType = cell?.column?.columnDef?.id

  switch (cellType) {
    case "organisation_id": {
      const organisation = rowData.organisation || {}
      return (
        <td key={cell.id}>
          <Link to={`/backend/organisations/${organisation.id}`}>{organisation.name}</Link>
        </td>
      )
    }
    case "unit_id": {
      const unit = rowData.unit || {}
      return (
        <td key={cell.id}>
          <Link to={`/backend/units/${unit.id}`}>{unit.name}</Link>
        </td>
      )
    }
    case "id": {
      const { name } = rowData
      return (
        <td key={cell.id}>{name}</td>
      )
    }
    case "actions": {
      const { id } = rowData
      return (
        <td key={cell.id} className="text-right">
          <Link to={`/backend/programs/${id}`} className="text-muted" title="Edit program">
            <FaPen />
          </Link>
        </td>
      )
    }
    default:
      return (
        <td key={cell.id}>
          {flexRender(
                      cell.column.columnDef.cell,
                      cell.getContext()
                    )}
        </td>
      )
  }
}

export default ProgramTableCell
